import {
  ARCHIVED_FILTER_NAME,
  BUILDING_FILTER_NAME,
  DATE_RANGE_FILTER_WITH_OVERDUE_DATE,
  DUE_DATE_FILTER_NAME,
  STATUS_FILTER_NAME,
} from '../../../../constants/filter'
import { getDateRangeParam } from '../../../../utils/filter'
import { BIRDVIEW_OPEN_REQUEST_STATUSES } from '../../DashboardBirdview.constants.api'

// A property row counts every open request of the building, not only the ones
// the manager owns.
export function getBirdviewBuildingOpenRequestsFilters(buildingId) {
  return {
    [ARCHIVED_FILTER_NAME]: false,
    [BUILDING_FILTER_NAME]: [buildingId],
    [STATUS_FILTER_NAME]: BIRDVIEW_OPEN_REQUEST_STATUSES,
  }
}

export function getBirdviewBuildingOverdueRequestsFilters(buildingId) {
  return {
    ...getBirdviewBuildingOpenRequestsFilters(buildingId),
    [getDateRangeParam(DUE_DATE_FILTER_NAME)]: [
      DATE_RANGE_FILTER_WITH_OVERDUE_DATE,
    ],
  }
}

export function toBirdviewBuildingItem(building) {
  return { id: building.id, title: building.title }
}
